// extracted by mini-css-extract-plugin
export default {"loader":"DR6F2","dots":"xFRyQ","dot":"kg51_","flicker":"GmoH4"};